
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { ConfigProvider } from 'antd';
import {Route, HashRouter ,Switch } from 'react-router-dom';//导入路由的一些组件

import {createStore} from "redux"//导入redux的状态机
import rootReducers from "./reducers"//reducer的集合体
import { Provider } from "react-redux"//redux的外层监控
import zhCN from 'antd/es/locale/zh_CN';
//import createHistory from 'history/createHashHistory'
//const history = createHistory();

import Login from './components/Login/index';//登录页面
import Content from './components/Content/Wrap/Warp';//首页
import Statement from './components/Content/Wrap/statement';//恶意申述页面
import NotFound from './components/Err/Err';//错误页面
import Compatible from './components/Compatible/Compatible';//兼容页面

const store=createStore(rootReducers);//创建顶级state

// const BrowserLogger = require('alife-logger');
// const __bl = BrowserLogger.singleton({pid:"eb6bglym0x@96e40ae3491bbfb",appType:"web"
// ,imgUrl:"https://arms-retcode.aliyuncs.com/r.png?"
// ,sendResource:true,enableLinkTrace:true,behavior:true
// ,enableConsole:true
// ,environment:"prod"
// });

//所有页面路由集合（不含子路由）
class Rou extends React.Component{
    render(){
        return (
            <ConfigProvider locale={zhCN}>
                <Provider store={store}>
                    <HashRouter >
                        <div>
                            <Switch>
                                <Route path="/Login" component={Login} />
                                <Route path="/Content" component={Content}/>
                                <Route path="/New" component={Statement} />
                                <Route path="/Compatible" component={Compatible} />
                                <Route exact path="/err" component={NotFound}/>
                                <Route component={NotFound} />
                            </Switch>
                        </div>
                    </HashRouter>
                </Provider>
            </ConfigProvider>

        );
    }
}
ReactDOM.render(<Rou/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js